// 22 Sep 2026 · Offline-Lesespiegel (IndexedDB via idb).
// Speichert erfolgreiche GET-Antworten je URL mit Zeitstempel, damit die App
// ohne Netz die zuletzt gesehenen Daten anzeigen kann. Rechnungs-PDFs werden
// bewusst NICHT gespeichert (siehe api.js — /files/ ist ausgenommen).
import { openDB } from "idb";

const DB_NAME = "wb-offline";
const STORE = "apiCache";
const META = "meta";

let _dbPromise = null;
function getDB() {
  if (!_dbPromise) {
    _dbPromise = openDB(DB_NAME, 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
        if (!db.objectStoreNames.contains(META)) db.createObjectStore(META);
      },
    });
  }
  return _dbPromise;
}

export async function setCached(key, data) {
  try {
    const db = await getDB();
    await db.put(STORE, { data, ts: Date.now() }, key);
  } catch { /* privacy mode / quota */ }
}

export async function getCached(key) {
  try {
    const db = await getDB();
    const rec = await db.get(STORE, key);
    return rec ? rec.data : undefined;
  } catch {
    return undefined;
  }
}

export async function setMeta(key, val) {
  try {
    const db = await getDB();
    await db.put(META, val, key);
  } catch { /* ignore */ }
}

export async function getMeta(key) {
  try {
    const db = await getDB();
    return await db.get(META, key);
  } catch {
    return undefined;
  }
}

// Kompletter Cache-Reset — bei Logout, abgelaufener Sitzung oder Admin-
// Zwangs-Logout. Löscht sowohl Datenspiegel als auch Meta (lastSync).
export async function clearAll() {
  try {
    const db = await getDB();
    await db.clear(STORE);
    await db.clear(META);
  } catch { /* ignore */ }
}
